export const OAUTH_ROUTE = `${process.env.REACT_APP_GOOGLE_OAUTH_ENDPOINT}/auth/facebook/login`;
export const REVIEW_SOCIAL_POST_PUBLISH_DATE_INSTANCE = 1;
export const MONTH_KEY_DATE_FORMAT = 'MMM YYYY';

export function isFacebookApp() {
  const ua = navigator.userAgent || navigator.vendor || (window as any)?.opera;
  return ua?.indexOf('FBAN') > -1 || ua?.indexOf('FBAV') > -1;
}
